// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { provision } from 'client/actions/enterprise/user';

import CodePage from './codePage';

const mapStateToProps: Object = ({ siteConfigs, translations, user }, ownProps) => {
  const redirect = _.get(ownProps, 'location.query.redirect', '');
  const user_id = _.get(user, 'oid', null);
  const id = _.get(ownProps, 'location.query.id', null);
  return {
    redirect,
    siteConfigs,
    translations,
    user_id,
    id,
  };
};

export default connect(mapStateToProps, { provision })(CodePage);
